import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=51bccdd4"
import script from "./publicity.vue?vue&type=script&lang=js"
export * from "./publicity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports